module.exports = __webpack_public_path__ + "static/media/instagram.9481ffc4.svg";